// extracted by mini-css-extract-plugin
export var attribution = "quoteBlock-module--attribution--827f7";
export var icon = "quoteBlock-module--icon--7b98a";
export var name = "quoteBlock-module--name--184ef";
export var quote = "quoteBlock-module--quote--f2123";
export var quoteBlock = "quoteBlock-module--quoteBlock--ffe84";
export var title = "quoteBlock-module--title--ddf03";